<template>
  <div class="all-group">
    <div class="item" v-for="(item,index) in list" :key="index">
      <div class="avatar">
        <img :src="item.avatar" alt />
        <span v-if="item.is_open_user == 1"></span>
      </div>

      <div class="info">
        <p class="p1">{{item.nickname}}</p>
        <p
          class="p2"
        >{{item.join_at | fomartTime('yyyy/MM/dd hh:mm:ss')}}{{item.is_open_user == 1 ? "开团":"参团"}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "all-group",
  data() {
    return {
      group_id: this.$route.query.group_id,
      list: []
    };
  },
  methods: {
    async getList() {
      this.list = await this.$http.get(
        `/api/app/spell/group/users/${this.group_id}`
      );
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.all-group {
  .item {
    display: flex;
    align-items: center;
    padding: 30px 30px 8px;
    .avatar {
      position: relative;
      margin-right: 20px;
      img {
        width: 110px;
        height: 110px;
        border-radius: 50%;
        box-shadow: #ddd 0 16px 30px;
      }
      span {
        position: absolute;
        width: 60px;
        height: 28px;
        left: 50%;
        bottom: -8px;
        margin-left: -30px;
        background: url("~@/assets/images/group/team-leader.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .info {
      .p1 {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(32, 36, 42, 1);
        line-height: 40px;
      }
      .p2 {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        line-height: 40px;
      }
    }
  }
}
</style>
